import { subject } from "../client";

export const getSubject = (params) => {
  console.log(params,"params");
  const user = {
    flag: "getSubject",
    parameters: {
      subject: {
        institutionId: params.institutionId,
        limit:params.limit,
        offset:params.offset
      },
    },
  };
  return subject.post("/get/subjects", user);
};

export const updateSubject = (params) => {
  const user = {
    flag: "updateSubject",
    parameters: {
      subject: params,
    },
  };
  return subject.post("/update/subject", user);
};

export const deleteSubject = (params) => {
  const user = {
    flag: "deleteSubject",
    parameters: {
      subject: params,
    },
  };
  return subject.delete("/delete/subject", { data: user });
};

export const addSubject = (params) => {
  const user = {
    flag: "addSubject",
    parameters: {
      subject: params,
    },
  };
  return subject.post("/add/subject", user);
};
